import React from "react";
import BannerBackground from "../Assets/home-banner-background-Blue.png";
import BannerImage from "../Assets/home-banner-image.png";
import Navbar from "./Navbar";
import { FiArrowRight } from "react-icons/fi";
import { CiTextAlignCenter } from "react-icons/ci";
const Home = () => {
  return (
    <div className="home-container">
 <Navbar />

      <div className="home-banner-container">
        <div className="home-bannerImage-container">
          <img src={BannerBackground} alt="" />
        </div>
        <div className="home-text-section">
          
          <h1 className="primary-heading" >
            <pre>Marokko Biz CoWorking
            </pre>
            <span class="subtext">Lot. Al Maghreb, Al Arabi D, lot No 76, Kenitra, Morocco</span>
          
          </h1>
          <p className="primary-text">

           <br/><br/>
           Welcome to Marokko Biz CoWorking<br/><br/>
            You an independent professional? or business owner?<br/>
            Do you need a reliable Proff. place of business? <br/>
            Professional services while on vacation? <br/><br/>
            Marokko Biz CoWorking offers flexible and affordable Place of business solutions tailored to your needs.
           
          </p> <a href="#services">
          <button className="secondary-button">
         Explore Our Services <FiArrowRight />{" "}
          </button>
          </a>
        </div>
        <div className="home-image-section">
          <img src={BannerImage} alt="" />
        </div>
      </div>
    </div>
  );
};

export default Home;
